import React,{useState,useEffect} from 'react'
import axios from '../../api/api'
import {toast} from 'react-toastify'

const MyAccount = () => {

  const name = window.localStorage.getItem('token');
  const user = JSON.parse(name).data._id;

  const [bankName,setBankName] = useState('')
  const [holdersName,setHoldersName] = useState('')
  const [accountNumber,setAccountNumber] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      const response = await axios.post(`/api/v1/users/accountinfo/${user}`,
        JSON.stringify({ bankName, holdersName, accountNumber }),
        { headers: { "Content-Type": "application/json" } }
      )
      toast("Successfully added your information");
      console.log(response)
    } catch (error) {
      console.log(error)
      toast.error('Account Details not added')
    }
  }

  const fetchData = async () => {
    try {
      const response = await axios.get(`/api/v1/users/accountinfo/${user}`);
      const data = response.data;

      // Set the state with the fetched data
      setBankName(data[0].bankName || '');
      setHoldersName(data[0].holdersName || '');
      setAccountNumber(data[0].accountNumber || '');
    } catch (error) {
      console.log(error);
      toast.error('Error fetching account details');
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []); 

  return (
    <div>
      <div className="mx-auto p-4 lg:container">
        <h1 className="text-3xl font-bold text-gray-800">Account details</h1>
        <div >       
          <form onSubmit={handleSubmit}>
            <div className='p-1'>
              <label htmlFor="">
                <input 
                  type="text" 
                  required
                  className='form-control block w-1/2 px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none'
                  placeholder='Bank Name'
                  value={bankName}
                  onChange={(e) => setBankName(e.target.value)}  
                />
              </label>
            </div>
            <div className='p-1'>
              <label htmlFor="">
                <input 
                  type="text" 
                  required
                  className='form-control block w-1/2 px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none'
                  placeholder='Account Name'
                  value={holdersName}
                  onChange={(e) => setHoldersName(e.target.value)}  
                />
              </label>
            </div>
            <div className='p-1'>
              <label htmlFor="">
                <input 
                  type="number" 
                  required
                  className='form-control block w-1/2 px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none'
                  placeholder='Account Number'
                  value={accountNumber}
                  onChange={(e) => setAccountNumber(e.target.value)}  
                />
              </label>
            </div>
            <div className='p-2'>
              <button className="bg-blue-600 text-white px-5 py-2 rounded-md">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default MyAccount
